import { RootEnv } from '@bringg-frontend/bringg-web-infra';

import RootStore from '../root-store';

export const createStore = (env: RootEnv): { RootStore: new () => RootStore; env: RootEnv } => {
	return { RootStore, env };
};
